<template>
  <div class="core corev2">
    <div class="container">
      <div class="row">
        <div class="core-ct">
          <a
            class="html5lightbox thm-btn"
            title="AFRIK EVEIL"
            href="https://www.youtube.com/embed/mObSx7bMNTE"
            ><img
              src="https://res.cloudinary.com/yanfomaweb/image/upload/v1533925908/afrikeveil/playbtn1.png"
              alt=""
          /></a>
          <div class="heading-it">
            <h1>{{ $t("discover") }}<span> Afrik Eveil</span></h1>
            <img
              src="https://res.cloudinary.com/yanfomaweb/image/upload/v1577295001/afrikeveil/title-line.png"
              alt=""
            />
          </div>
          <div class="core-text">
            <span>{{ $t("everything") }}</span
            ><span class="embbed">{{ $t("AboutUs") }} !!!</span>
          </div>
          <!--<iframe width="1080" height="500" src="https://www.youtube.com/embed/-xDcvGWgTNk" frameborder="0" allowfullscreen></iframe>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LightBoxVideo",
  props: {
    blogs: {}
  }
};
</script>
<style scoped lang="scss">
.corev2 {
  background-image: linear-gradient(to right, #2b628dd5, #0d8a90fb);
}
.core .heading-it {
  margin-bottom: 60px;
  text-align: center;
}
.core .heading-it h1 {
  font-family: "arial", sans-serif;
  font-size: 36px;
  color: #f9f9f9;
  font-weight: 700;
  text-transform: "";
  margin-bottom: 15px;
  line-height: 1.714em;
}
.core .heading-it h1 span {
  color: #5bbc2e;
}
.core .core-text span {
  font-size: 12px;
  letter-spacing: 0.2em;
  color: #fff !important;
  margin-left: 15px;
  margin-right: 15px;
}
core .core-text span.embbed {
  text-transform: uppercase;
}
.core-text span {
  font-size: 12px;
  letter-spacing: 0.2em;
  color: #abaaaa;
  margin-left: 15px;
  margin-right: 15px;
}
.core {
  background-size: cover;
  background-position: center;
  padding: 120px 0;
  text-align: center;
  min-height: 500px;
  background-attachment: fixed;
}
</style>
